<template>
    <div class="page-deliver-home">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">送貨上門設定</div>
        </div>

        <div class="card-block">

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">
                        <!-- <em class="red">* </em>-->
                        <span>搜索</span>
                    </label>
                    <Input size="small" v-model="form.id"/>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleSearch">搜索</div>
                        <div class="pg-btn style3" @click="handleToAdd">添加</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                form: {
                    id: ''
                },
                isLoading: true,
                table: {
                    column: [
                        {
                            title: '區域',
                            key: 'addres',
                            align: 'center',
							sortable: true,
                            width: 100
                        },
                        {
                            title: '時間段',
                            key: 'timedata',
                            align: 'center',
							sortable: true,
							width: 300,
							render: (h, params) => {
								let arr = (params.row.timedata || "")
								return h('div',arr.map(function(item,index) {
									return h('h1', {
										domProps:{
											innerHTML: item || "沒有時間段"
										}
									})
								}))
							}
                        },
                        {
                            title: '減免金額',
                            key: 'discount',
                            align: 'center',
							sortable: true,
							width: 50
                        },
                        {
                            title: '區域負責人電話',
                            key: 'phone',
                            align: 'center',
							sortable: true,
							width: 100
                        },
                        {
                            title: '描述',
                            key: 'description',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '備註',
                            key: 'remarks',
                            align: 'center',
							sortable: true,
                        },
						{
                            title: '創建時間',
                            key: 'created_at',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            width: 150
                        }
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            handleToAdd()
            {
                this.$router.push({path: '/deliverHomeAdd'});
            },
            getList()
            {
                let form = this.form;
                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.deliverHomeList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        id: form.id
                    }
                }).then((res) =>
                {
					
                    this.isLoading = false;
                    if (res.code == 200)
                    {
                        let tempArr = [];
                        let resData = res.data;
                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                addres: resData[i].addres,
                                discount: resData[i].discount,
                                id: resData[i].id,
                                phone: resData[i].phone,
                                timedata: resData[i].timedata,
								description: resData[i].description,
								remarks: resData[i].remarks,
								created_at:resData[i].created_at
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },
            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },
            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/deliverHomeEdit?id=' + tableData[index].id});
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.deliverHomeDelete + '/' + tableData[index].id,
                            method: 'post'
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 200)
                            {
                                this.$Utils.showSuccess(res.msg);
                                this.pageIndex = 1;
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });

                    }
                });
            },
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'DeliverHome.scss';
</style>